import { ApplicationState, ConnectedReduxProps } from '../../store';
import { Button, MenuItem, Modal, Select, TextField, SelectChangeEvent } from '@mui/material';
import { CaseResponse, CaseSearch, UserAccountResponse } from '../../store/case/model';
import {  archiveCase,
          archiveCaseClose,
          archiveCaseOpen,
          assignUser,
          assignUserClose,
          assignUserOpen,
          changeAssignedUserId,
          clearCases,
          dearchiveCase,
          fetchCases,
          fetchCasesCount,
          refuseCase,
          refuseCaseClose,
          refuseCaseOpen,
          refuseReasonChange,
          refuseReasonTextChange,
          selectCase,
          fetchParties,
          fetchAssignedParties,
          setInProgressState
        } from '../../store/case';
import CancelIcon from '@mui/icons-material/Cancel';
import CaseDetails from './case-details';
import CaseDetailsHeader from './case-details-header';
import CaseSearchBar from '../custom/case-search-bar';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dispatch } from 'redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import InfiniteScroll from 'react-infinite-scroll-component';
import React from 'react';
import { TypeCodeTranslation } from '../../business/models/shared.model';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './case-list.module.css';
import { ArchiveCaseModal } from '../common/archiveCaseModal';
import { AssignCaseModal } from '../common/assignCaseModal';

interface PropsFromState {
  readonly cases: CaseResponse[];
  readonly requestSent: boolean;
  readonly caseSearch: CaseSearch;
  readonly showSearchBar: boolean;
  readonly showRefuseModal: boolean;
  readonly showArchiveModal: boolean;
  readonly selectedCase?: CaseResponse | undefined;
  readonly refuseReasons: TypeCodeTranslation[];
  readonly refuseReasonTC: string;
  readonly refuseReasonText: string;
  readonly currentLanguageTC: string;
  readonly showAssignModal: boolean;
  readonly assignableUsers: UserAccountResponse[];
  readonly selectedClaimNotificationId: number;
  readonly selectedAssignedUserId: number | '';
}

interface PropsFromDispatch {
  readonly fetchCases: typeof fetchCases;
  readonly clearCases: typeof clearCases;
  readonly selectCase: typeof selectCase;
  readonly refuseCaseClose: typeof refuseCaseClose;
  readonly refuseCaseOpen: typeof refuseCaseOpen;
  readonly refuseReasonChange: typeof refuseReasonChange;
  readonly refuseReasonTextChange: typeof refuseReasonTextChange;
  readonly refuseCase: typeof refuseCase;
  readonly archiveCaseClose: typeof archiveCaseClose;
  readonly archiveCaseOpen: typeof archiveCaseOpen;
  readonly archiveCase: typeof archiveCase;
  readonly dearchiveCase: typeof dearchiveCase;
  readonly assignUserOpen: typeof assignUserOpen;
  readonly assignUserClose: typeof assignUserClose;
  readonly assignUser: typeof assignUser;
  readonly changeAssignedUserId: typeof changeAssignedUserId;
  readonly fetchCasesCount: typeof fetchCasesCount;
  readonly fetchParties: typeof fetchParties;
  readonly fetchAssignedParties: typeof fetchAssignedParties;
  readonly setInProgressState: typeof setInProgressState;
}
type AllProps = PropsFromState &
  PropsFromDispatch &
  ConnectedReduxProps;

interface State {
  expertName: string;
}

class CaseList extends React.Component<AllProps, State> {

  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.state = {
      expertName: ''
    };
  }

  fetchMoreCases = () => {
    if (this.props.requestSent) {
      return;
    }

    this.props.fetchCases(this.props.caseSearch, this.props.cases.length, false);
  }

  componentDidMount() {
    this.props.fetchCasesCount();
    this.props.fetchParties();
    this.props.fetchAssignedParties();
    if (this.props.cases.length <= 0 && !this.props.requestSent) {
      this.props.fetchCases(this.props.caseSearch, 0, false);
    }
  }

  get items() {
    return this.props.cases.map((item, index) => {
      return (
        <CaseDetails
          case={item}
          key={index}
          />
      );
    });
  }

  get searchBar() {
    return this.props.showSearchBar ? <CaseSearchBar {...this.props} /> : null;
  }

  private deleteDisabled(): boolean {
    const deleteEnabled = this.props.selectedCase
      && this.props.selectedCase.refuseReasonTC && this.props.selectedCase.refuseReasonTC !== ''
      && this.props.selectedCase.refuseReasonText && this.props.selectedCase.refuseReasonText !== '';

    return deleteEnabled === undefined ? true : !deleteEnabled;
  }

  render() {
    return (
      <div className={styles.container}>
        {this.searchBar}

        <div className={styles.listHeaderContainer}>
          <CaseDetailsHeader />
        </div>

        <div className={styles.listContainer} id='scrollableDiv'>
          <InfiniteScroll
            dataLength={this.items.length}
            next={() => this.fetchMoreCases()}
            hasMore={true}
            loader={null}
            scrollableTarget='scrollableDiv'
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>-</b>
              </p>
            }>
            {this.items}
          </InfiniteScroll>
          <Modal
            aria-labelledby='simple-modal-title'
            aria-describedby='simple-modal-description'
            open={this.props.showRefuseModal}
            onClose={() => this.props.refuseCaseClose()}
          >
            <div className={styles.refuseModal}>
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <Select
                    value={this.props.selectedCase && (this.props.selectedCase.refuseReasonTC || '')}
                    onChange={(event: SelectChangeEvent<string>) => {
                      this.props.refuseReasonChange(event.target.value);
                    }}
                    displayEmpty
                    className={styles.select}
                  >
                    <MenuItem value='' key='' disabled>
                      {this.localization.get('home.refuseReason')}
                    </MenuItem>
                    {this.props.refuseReasons.filter(x => x.language === this.props.currentLanguageTC).map(o => <MenuItem value={o.translation} key={o.typeCodeValue}>{o.translation}</MenuItem>)}
                  </Select>
                </div>
              </div>
              <br />
              <div className={styles.row}>
                <div className={`${styles.item} ${styles.border}`}>
                  <TextField
                    value={this.props.selectedCase && (this.props.selectedCase.refuseReasonText || '')}
                    onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      this.props.refuseReasonTextChange(event.target.value);
                    }}
                    className={styles.textField}
                    placeholder={this.localization.get('home.refuseReason')}
                    multiline={true}
                    minRows={3}
                    maxRows={5}
                  />
                </div>
              </div>
              <div className={styles.row}>
                <Button
                  variant='contained'
                  className={styles.button}
                  onClick={() => this.props.refuseCaseClose()} >
                  {this.localization.get('shared.cancel')}
                  <CancelIcon className={styles.rightIcon} />
                </Button>
                <Button
                  variant='contained'
                  color='secondary'
                  disabled={this.deleteDisabled()}
                  className={styles.button}
                  onClick={() => {
                    if (this.props.selectedCase) { this.props.refuseCase(this.props.selectedCase); }
                  }} >
                  {this.localization.get('home.refuse.tooltip')}
                  <DeleteIcon className={styles.rightIcon} />
                </Button>
              </div>
            </div>
          </Modal>
          <ArchiveCaseModal
            selectedCase={this.props.selectedCase}
            archiveCaseClose={this.props.archiveCaseClose}
            archiveCase={this.props.archiveCase.bind(this)}
            dearchiveCase={this.props.dearchiveCase.bind(this)}
            showArchiveModal={this.props.showArchiveModal}
        ></ArchiveCaseModal>
          <AssignCaseModal
              selectedCase={this.props.selectedCase}
              showAssignModal={this.props.showAssignModal}
              assignableUsers= {this.props.assignableUsers}
              selectedAssignedUserId={this.props.selectedAssignedUserId}
              selectedClaimNotificationId={this.props.selectedClaimNotificationId}
              assignUserOpen={this.props.assignUserOpen.bind(this)}
              assignUserClose={this.props.assignUserClose}
              assignUser={this.props.assignUser.bind(this)}
              changeAssignedUserId={this.props.changeAssignedUserId.bind(this)}
          ></AssignCaseModal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ caseState, shared }: ApplicationState) => ({
  cases: caseState.cases,
  requestSent: caseState.requestSent,
  caseSearch: caseState.caseSearch,
  showSearchBar: caseState.searchBarVisible,
  showRefuseModal: caseState.refusalModalVisible,
  showArchiveModal: caseState.archiveModalVisible,
  selectedCase: caseState.selectedCase,
  refuseReasons: caseState.caseTypeCodes.refuseReasons,
  refuseReasonTC: caseState.selectedCase.refuseReasonTC,
  refuseReasonText: caseState.selectedCase.refuseReasonText,
  currentLanguageTC: shared.currentLanguage,
  showAssignModal: caseState.showAssignModal,
  assignableUsers: caseState.assignableUsers,
  selectedClaimNotificationId: caseState.selectedClaimNotificationId,
  selectedAssignedUserId: caseState.selectedAssignedUserId
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCases: (caseSearch: CaseSearch, offset: number, searchClicked: boolean) => dispatch(fetchCases(caseSearch, offset, searchClicked)),
  clearCases: () => dispatch(clearCases()),
  selectCase: (selectedCase: CaseResponse) => dispatch(selectCase(selectedCase)),
  refuseCase: (selectedCase: CaseResponse) => dispatch(refuseCase(selectedCase)),
  refuseCaseOpen: (selectedCase: CaseResponse) => dispatch(refuseCaseOpen(selectedCase)),
  refuseReasonChange: (refuseReasonTC: string) => dispatch(refuseReasonChange(refuseReasonTC)),
  refuseReasonTextChange: (refuseReasonText: string) => dispatch(refuseReasonTextChange(refuseReasonText)),
  refuseCaseClose: () => dispatch(refuseCaseClose()),
  archiveCaseOpen: (selectedCase: CaseResponse) => dispatch(archiveCaseOpen(selectedCase)),
  archiveCaseClose: () => dispatch(archiveCaseClose()),
  archiveCase: (selectedCase: CaseResponse) => dispatch(archiveCase(selectedCase)),
  dearchiveCase: (selectedCase: CaseResponse) => dispatch(dearchiveCase(selectedCase)),
  assignUserOpen: (claimNotificationId: number) => dispatch(assignUserOpen(claimNotificationId)),
  assignUserClose: () => dispatch(assignUserClose()),
  assignUser: (userId: number, claimNotificationId: number, expertName: string) => dispatch(assignUser(userId, claimNotificationId, expertName)),
  changeAssignedUserId: (userId: number) => dispatch(changeAssignedUserId(userId)),
  fetchCasesCount: () => dispatch(fetchCasesCount()),
  fetchParties: () => dispatch(fetchParties()),
  fetchAssignedParties: () => dispatch(fetchAssignedParties()),
  setInProgressState: (selectedCase: CaseResponse) => dispatch(setInProgressState(selectedCase)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseList);
